<template>
  <div class="card-base ph-10" v-loading="isLoading">
    <div class="widget-header">
      <h5 class="pb-10 pt-10 display-block">
        Progressions
        <el-link @click="loadDocumentation('dashboard-threat-progressions')" :underline="false">
          <i class="material-icons">help_outline</i>
        </el-link>
        <div class="subtitle2 display-inline-block">Past 1 month</div>
      </h5>
      <!-- <el-divider></el-divider> -->
      <div class="flex justify-center align-center full-width">
        <div class="widget-info box grow text-truncate animated fadeInLeft">
          <!-- <el-row class="list-summary">
            <el-col :span="12">
              <span class="body2"></span>
            </el-col>
            <el-col :span="12" class="float-right">
              <span class="body2 float-right">
                <el-select
                  v-model="sortSel"
                  @change="sortList(sortSel)"
                  placeholder="Select"
                  class="body2"
                  style="max-width: 100px"
                >
                  <el-option v-for="item in sortOptions" :key="item.value" :label="item.label" :value="item.value">
                    <span class="body2">{{ item.label }}</span>
                  </el-option>
                </el-select>
              </span>
            </el-col>
          </el-row> -->
          <el-divider></el-divider>
          <el-row v-if="trailsList.length == 0">
            <div class="progression-container">
              <div style="padding: 15px 39.5px 15px 32.5px">
                <img style="height:75.5px; width:203px;" src="/static/images/binoculars.svg" alt="BINOCULARS" />
              </div>
              <div class="progressions-text">
                No active progressions detected. Continuously monitoring all active trails
              </div>
            </div>
          </el-row>
          <el-row class="c-table">
            <div class="page-dashboard widget-info">
              <div
                style="max-height: '65px'; padding: '2px 0px'"
                class="c-table_row trail-list"
                v-for="trail in pageEntries"
                :key="trail.trailIdHash"
              >
                <dashboard-trail-info-card parent=".trail-list" :trail="trail" />
              </div>
            </div>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-pagination
                class="float-right"
                small
                layout="prev, pager, next"
                :hide-on-single-page="true"
                :current-page.sync="currentPage"
                :page-size="pageSize"
                :total="trailsList.length"
                @current-change="pageChange"
              >
              </el-pagination>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import loadDocumentationMixin from '@/mixins/loadDocumentationMixin'
import { registerInverval, destroyInverval } from '@/utilities/global.interval'

import { TRAIL_DASHBOARD_USER_PREF } from '@/store/modules/user_pref/user-pref.type'
import { DASHBOARD_POLLING_INTERVAL } from '@/constants/polling-interval.constants'
import {
  TRAILSINFO_LIST_REQUEST,
  TRAILSINFO_LIST_STATUS_RESET  
} from '@/store/modules/trails/trailsinfo.type'
import DashboardTrailInfoCard from '@/components/dashboard/DashboardTrailInfoCard.vue'

export default {
  name: 'ThreatProgressionList',
  mixins: [loadDocumentationMixin],
  props: {
    title: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  data () {
    return {
      isLoading: false,
      currentPage: 1,
      startingPageNum: 1,
      pageSize: 5,
      assignedToMe: false,
      activeTab: 'all',
      sortOptions: [
        {
          value: 'desc_datetime',
          label: 'Latest'
        },
        {
          value: 'asc_datetime',
          label: 'Oldest'
        }
      ],
      trailsList: [],
      trailsIntervalId: {},
      trailvlistKey: 0 // key used to re-render trails list
    }
  },
  mounted () {
    if (this.$el.clientHeight) {
      try {
        let listTable = this.$el.getElementsByClassName('c-table el-row')
        if (listTable) {
          let size = listTable[0].clientHeight / 50
          this.pageSize = Math.floor(size)
        }
      } catch (error) {
        console.log(true)
      }
    }
  },
  created () {
    if (_.isEmpty(this.trailsIntervalId)) {
      this.isLoading = true
      this.loadTrailInfo()
    }
  },
  methods: {
    pollTrailInfo () {
      this.trailsIntervalId = setTimeout(() => {
        this.loadTrailInfo()
      }, DASHBOARD_POLLING_INTERVAL)

      registerInverval(this.trailsIntervalId)
    },
    loadTrailInfo () {
      if (this.trailsIntervalId) {
        destroyInverval(this.trailsIntervalId)
      }
      Promise.all([
        this.$store.dispatch(TRAILSINFO_LIST_REQUEST, {
          state: 'ACTIVE',
          dateRangeSel: 'PAST_1_MONTH'
        })
      ]).then(
        trails => {
          this.filterList()
          this.isLoading = false
          this.pollTrailInfo()
        },
        errMsg => {
          console.log(errMsg)
          this.pollTrailInfo()
        }
      )
    },
    sortList (sortOrder) {
      // if sort property changes to datetime for latest or earliest, use lastIocSeenTime
      let prop = 'lastIocSeenTime'

      this.trailsList.sort((a, b) => {
        if (sortOrder.includes('desc')) {
          return b[prop] - a[prop]
        }
        return a[prop] - b[prop]
      })
    },
    filterTab (tab) {
      switch (tab.name) {
        case 'unassigned':
          this.trailsList = _.filter(this.allTrails, trail => {
            return _.isEmpty(trail.ownerId.email)
          })
          break
        default:
          this.trailsList = this.allTrails
      }
      this.sortList(this.sortSel)
    },
    filterList (filter) {
      if (this.activeTab === 'all' && this.assignedToMe) {
        this.trailsList = _.filter(this.allTrails, trail => {
          return trail.ownerId.email === this.userProfile.email
        })
      } else if (this.activeTab === 'unassigned') {
        this.trailsList = _.filter(this.allTrails, trail => {
          return _.isEmpty(trail.ownerId.email)
        })
      } else {
        this.trailsList = this.allTrails
      }

      this.trailsList.forEach(trail => {
        trail.killChainData.datasets[0].backgroundColor.forEach((color, idx) => {
          if (color === '#1a90fa') {
            trail.killChainData.datasets[0].backgroundColor[idx] = '#f24a6c'
          }
        })
      })

      this.sortList(this.sortSel)
    },
    pageChange () {
      let pageEl = this.$el.querySelectorAll('.c-table')
      pageEl[0].scrollTop = 0
    },
    resetPageNum () {
      this.currentPage = 1
    }
  },
  computed: {
    allTrails () {
      let combinedActiveTrails = this.activeTrailsinfoRecords.models
      let emptyFingerprints = _.filter(combinedActiveTrails, trail => {
        return _.isEmpty(trail.fingerprint)
      })
      let fingerprintTrails = _.filter(combinedActiveTrails, trail => {
        return !_.isEmpty(trail.fingerprint)
      })
      fingerprintTrails = _.chain(fingerprintTrails)
        .sort((a, b) => {
          return b.lastIocSeenTime - a.lastIocSeenTime
        })
        .groupBy('fingerprint')
        .map(trail => {
          let mostRecentActiveTrail = trail[0]
          mostRecentActiveTrail.similarFingerprintCount = trail.length - 1 // exclude itself (trail[0])
          return mostRecentActiveTrail
        })
        .value()
      return emptyFingerprints.concat(fingerprintTrails)
    },
    sortSel: {
      get: function () {
        // if (this.trailsDashboardUserSetting) {
        //   return this.trailsDashboardUserSetting.orderBy
        // }
        return 'desc_datetime'
      },
      set: function (sortSel) {
        this.$store.dispatch(TRAIL_DASHBOARD_USER_PREF, { orderBy: sortSel })
      }
    },
    pageSummary () {
      let startRecordCount = (this.currentPage - 1) * this.pageSize
      let endRecordCount = this.pageSize * this.currentPage
      if (this.pageEntries.length < this.pageSize) {
        endRecordCount = this.trailsList.length
      }
      let recordCount = `${startRecordCount + 1}-${endRecordCount}`
      return `${recordCount} of ${this.trailsList.length}`
    },
    pageEntries () {
      return this.trailsList.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
    },
    ...mapGetters(['userProfile', 'activeTrailsinfoRecords', 'trailsDashboardUserSetting'])
  },
  beforeDestroy () {
    // kill interval calls
    this.pollTrailInfo = function () {}
    destroyInverval(this.trailsIntervalId)

    this.$store.dispatch(TRAILSINFO_LIST_STATUS_RESET)    
  },
  components: {
    DashboardTrailInfoCard
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/riskscore_colors.css';

.card-base {
  height: 100%;

  .widget-header {
    height: inherit;
  }

  .c-table,
  .widget-info {
    height: calc(100%- 15px);
  }
}

.material-icons {
  font-size: 20px;
  color: var(--aluminum-400);
  line-height: 27px;
  vertical-align: text-top;
}

.el-divider--horizontal {
  display: block;
  height: 1px;
  width: calc(100%);
  margin-left: 10px;
  margin-top: 5px;
  margin-bottom: 0px;
}

span {
  margin-left: 10px;
  font-weight: normal;

  &.ml-20 {
    margin-left: 20px;
  }

  &.ml-0 {
    margin-left: 0px;
  }
}

>>> .el-select .el-input__inner {
  border: none;
  height: 20px;
  line-height: 20px;
}

>>> .el-select__caret {
  line-height: 20px;
}

.progression-container{
  height: inherit;
  width: inherit;
  padding-left: 15px;
  padding-right: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.progressions-text{
  height: 60px;
  width: 221px;
  color: #454B60;
  font-size: 13px;
  letter-spacing: 0;
  line-height: 20px;
  text-align: center;
  margin-left: 26px;
  margin-right: 30px;
  white-space: initial;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/ThreatProgressionList.vue